import useImageLayer from '@frontend/js/hooks/useImageLayer';
import './image-layer.scss';

export default function ImageLayer({
    children,
    level = 2,
    className = '',
    overlayOpacity = 1,
    overlayBlendMode = 'difference',
    backdropOpacity = 0,

}) {
    const { style } = useImageLayer(level);
    const overlayStyle = {
        opacity: overlayOpacity,
        mixBlendMode: overlayBlendMode,
    };
    const backdropStyle = {


        opacity: backdropOpacity,
    };

    return (
        <div className={`imageLayer ${className}`.trim()} style={style}>
            <div className="imageLayer__base">{children}</div>
            <div className="imageLayer__backdrop" style={backdropStyle} aria-hidden="true" />
            <div className="imageLayer__overlay" style={overlayStyle} aria-hidden="true" />
        </div>
    );
}
